import React from 'react';
import { Col, Row } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import http from 'src/services/httpService';
import Input from 'src/componentes/input';
import ColaboradorSimplificadoLookup from 'src/lookups/ColaboradorSimplificadoLookup';
import { capitalizeFirstLetter } from 'src/utils/string';
import StatusAcaoLookup from 'src/lookups/status-acao';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import DatePicker from 'src/componentes/date-picker';
import PeriodicidadeLookup from 'src/lookups/periodicidade';
import Checkbox from 'src/componentes/checkbox';
import TemaEstrategicoLookup from 'src/lookups/tema-estrategico';
import ItemCentroCustoLookup from 'src/lookups/item-centro-custo';
import PacoteLookup from 'src/lookups/pacote';
import ItemLookup from 'src/lookups/item';
import FarolAcaoLookup from 'src/lookups/farol-acao';
import TipoItemLookup from 'src/lookups/tipo-item';
import TipoAcaoLookup from 'src/lookups/tipo-acao';
import DesdobramentoLookup from 'src/lookups/desdobramento';
import ClassificacaoLookup from 'src/lookups/classificacao-mo';
import NivelAcaoLookup from 'src/lookups/nivel-acao';
import MatrizRiscoLookup from 'src/lookups/matriz-risco';
import TagLookup from 'src/lookups/TagLookup';
import GrauRiscoLookup from 'src/lookups/grau-risco';
import AuditoriaRiscoLookup from 'src/lookups/auditoriaRisco';
import DesenharCampoCustomizado from '../item/campo-customizado/componentes/desenhar';
import TipoFiltroDataLookup from 'src/lookups/tipo-filtro-data';
import ControlSelfAssessmentLookup from 'src/lookups/controlSelfAssessment';
import StatusBaselineLookup from 'src/lookups/StatusBaselineLookup';
import PanelCollapse from 'src/componentes/panel-collapse';
import DiasParaVencimentoFilter from 'src/componentes/DiasParaVencimentoFilter';
import PontoControleLookup from 'src/lookups/ControleLookup';
import PerdaOperacionalLookup from 'src/lookups/PerdaOperacionalLookup';
import PesquisaClimaLookup from 'src/lookups/PesquisaClimaLookup';
import { ADDONS } from 'src/utils/constants';
import TIPOS_ORIGEM_FILTRO_ACAO from './tipos-origem-filtro';

class OrganizacaoSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      configuracoes: null,
      exibirClassificacao: false,
      filtroDefault: {
        tipoFiltroData: this.props?.model?.getModel('tipoFiltroDataCriacaoAcao')
          ?.value && {
          id: this.props.model.getModel('tipoFiltroDataCriacaoAcao').value.id,
          descricao: this.props.model.getModel('tipoFiltroDataCriacaoAcao')
            .value.descricao,
        },
        dataInicio:
          this.props.model &&
          this.props.model.getModel('dataInicialCriacaoAcao').value
            ? this.props.model.getModel('dataInicialCriacaoAcao').value
            : null,
        dataTermino:
          this.props.model &&
          this.props.model.getModel('dataFinalCriacaoAcao').value
            ? this.props.model.getModel('dataFinalCriacaoAcao').value
            : null,
      },
    };
  }

  componentDidMount() {
    let { moduloAtual } = this.props;

    http.get(`/AcaoConfiguracao/ObterConfiguracoes`).then((response) => {
      this.setState({
        configuracoes: response?.data,
      });
    });

    if (moduloAtual.id === 2) {
      http
        .post(`/CentroCusto/ObterConfiguracaoSistema`, {})
        .then((response) => {
          this.setState({
            exibirClassificacao: response.data.exibirClassificacao,
          });
        });
    }

    this.updateStatusField();

    this.props.model
      .getModel('tipoFiltroDataCriacaoAcao')
      .requestChange(this.state.filtroDefault.tipoFiltroData);
    this.props.model
      .getModel('dataInicialCriacaoAcao')
      .requestChange(this.state.filtroDefault.dataInicio);
    this.props.model
      .getModel('dataFinalCriacaoAcao')
      .requestChange(this.state.filtroDefault.dataTermino);
    this.getOptionsPeriodo();
  }

  getOptionsPeriodo() {
    http
      .post(`/TipoFiltroDataLookup/Search`, {
        pageSize: 999999,
      })
      .then((response) => {
        const list = response.data.list;
        this.setState({
          filtroDefault: {
            ...this.state.filtroDefault,
          },
          options: list,
        });
      });
  }

  // Novo filtro Multi - Sem impactar o antigo (outras telas, etc.)
  updateStatusField() {
    const { model } = this.props || {};

    const status = model.getModel('status').value;

    if (status) {
      const listaStatus = model.getModel('listaStatus').value;
      if (!listaStatus || listaStatus?.length === 0) {
        model.getModel('listaStatus').requestChange([{ ...status }]);
        model.getModel('status').requestChange(null);
      }
    }
  }

  handleChangeClassificacao(value) {
    let { model } = this.props;

    model.getModel('classificacao').requestChange(value);

    model.getModel('pacote').requestChange(null);
    model.getModel('pacoteId').requestChange(null);
    model.getModel('centroCusto').requestChange(null);
    model.getModel('centroCustoId').requestChange(null);

    this.setState({
      classificacaoId: value ? value.id : null,
    });
  }

  handleChangeFiltro(field, value) {
    const { model } = this.props;
    model.getModel(field).requestChange(value);
  }

  render() {
    let {
      model,
      resources,
      intl,
      moduloAtual,
      configuracaoSistema,
      addons = [],
    } = this.props;
    let { configuracoes, exibirClassificacao } = this.state;

    const possuiAddonPerdaOperacional =
      addons?.find((x) => x.id === ADDONS.PERDA_OPERACIONAL && x.ativo) != null;
    const possuiAddonPesquisaClima =
      addons?.find((x) => x.id === ADDONS.PESQUISA_CLIMA && x.ativo) != null;
    let classificacaoId = exibirClassificacao
      ? model.getModel('classificacao') &&
        model.getModel('classificacao').value != null
        ? model.getModel('classificacao').value.id
        : -1
      : null;

    return (
      <div style={{ padding: 0, margin: 0 }}>
        {/* 1 - IDENTIFICAÇÃO DA AÇÃO */}
        <PanelCollapse
          header={capitalizeFirstLetter(
            intl.formatMessage(
              { id: 'identificacaoAcao' },
              { acao: resources.acao }
            )
          )}
          open={true}
          ehAccordionDrawer={true}
        >
          <Row>
            <Col md={12}>
              <Input model={model.getModel('descricao')} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Input model={model.getModel('codigo')} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ItemLookup
                clearable={true}
                multi={true}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'item' })
                  ),
                  value: model.getModel('itens').value,
                  requestChange: model.getModel('itens').requestChange,
                }}
                data={{ ehTelaAcao: true }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Checkbox
                className="d-inline-block mr-2"
                model={model.getModel('incluirItensFormula')}
              />
              <Checkbox
                className="d-inline-block mr-2"
                model={model.getModel('incluirDesdobramento')}
              />
              <Checkbox
                className="d-inline-block mr-2"
                style={{ marginBottom: 15 }}
                model={model.getModel('incluirImpactosIndiretos')}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <StatusAcaoLookup
                multi
                clearable
                model={{
                  label: intl.formatMessage({ id: 'status' }),
                  value: model.getModel('listaStatus').value,
                  requestChange: model.getModel('listaStatus').requestChange,
                }}
              />
            </Col>
            <Col md={12}>
              <FarolAcaoLookup
                multi
                clearable
                model={{
                  label: capitalizeFirstLetter(resources.farol),
                  value: model.getModel('farol').value,
                  requestChange: model.getModel('farol').requestChange,
                }}
              />
            </Col>
          </Row>
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.podeVisualizarTag && (
              <Row>
                <Col md={12}>
                  <TagLookup
                    multi
                    model={{
                      label: capitalizeFirstLetter(
                        intl.formatMessage(
                          { id: 'tags' },
                          { tags: resources.tags }
                        )
                      ),
                      value: model.getModel('tags').value,
                      requestChange: model.getModel('tags').requestChange,
                    }}
                    data={{ funcionalidadesIdSelecionaveis: [6] }}
                    podeEditar={false}
                  />
                </Col>
              </Row>
            )}
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.tipoAcao && (
              <Row>
                <Col md={12}>
                  <TipoAcaoLookup
                    clearable
                    model={{
                      label: intl.formatMessage(
                        { id: 'tipoAcao' },
                        { acao: resources.acao }
                      ),
                      value: model.getModel('tipoAcao').value,
                      requestChange: model.getModel('tipoAcao').requestChange,
                    }}
                  />
                </Col>
              </Row>
            )}
          <Row>
            <Col md={12}>
              <NivelAcaoLookup
                clearable
                multi
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'nivelAcao' },
                      { acao: resources.acao }
                    )
                  ),
                  value: model.getModel('nivelAcao').value,
                  requestChange: model.getModel('nivelAcao').requestChange,
                }}
              />
            </Col>
          </Row>
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.tipoOrigem && (
              <Row>
                <Col md={12}>
                  <TipoItemLookup
                    clearable
                    model={{
                      label: intl.formatMessage({ id: 'tipoOrigem' }),
                      value: model.getModel('tipoOrigem').value,
                      requestChange: model.getModel('tipoOrigem').requestChange,
                    }}
                    data={{
                      tiposIdSelecionaveis: TIPOS_ORIGEM_FILTRO_ACAO,
                    }}
                  />
                </Col>
              </Row>
            )}
          <Row>
            <Col md={12}>
              <AuditoriaRiscoLookup
                clearable={true}
                multi={true}
                model={{
                  label: capitalizeFirstLetter(resources.auditorias),
                  value: model.getModel('auditorias').value,
                  requestChange: model.getModel('auditorias').requestChange,
                }}
              />
            </Col>
          </Row>
          {possuiAddonPerdaOperacional && (
            <Row>
              <Col md={12}>
                <PerdaOperacionalLookup
                  clearable={true}
                  multi={true}
                  model={{
                    label: capitalizeFirstLetter(
                      intl.formatMessage({ id: 'labelPerdaOperacional' })
                    ),
                    value: model.getModel('perdasOperacionais').value,
                    requestChange:
                      model.getModel('perdasOperacionais').requestChange,
                  }}
                />
              </Col>
            </Row>
          )}
          {possuiAddonPesquisaClima && (
            <Row>
              <Col md={12}>
                <PesquisaClimaLookup
                  multi
                  model={{
                    label: capitalizeFirstLetter(resources.pesquisas),
                    value: model.getModel('pesquisasClima').value,
                    requestChange:
                      model.getModel('pesquisasClima').requestChange,
                  }}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col md={12}>
              <ControlSelfAssessmentLookup
                clearable={true}
                multi={true}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'labelControlSelfAssessment' })
                  ),
                  value: model.getModel('controlSelfAssessments').value,
                  requestChange: model.getModel('controlSelfAssessments')
                    .requestChange,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <PontoControleLookup
                clearable={true}
                multi={true}
                model={{
                  label: capitalizeFirstLetter(resources.pontosdecontrole),
                  value: model.getModel('pontosDeControle').value,
                  requestChange:
                    model.getModel('pontosDeControle').requestChange,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Checkbox
                model={{
                  label: intl.formatMessage(
                    { id: 'label.apenasAcoesModuloAtual' },
                    { acoes: resources.acoes }
                  ),
                  value: model.getModel('apenasAcoesModuloAtual').value,
                  requestChange: model.getModel('apenasAcoesModuloAtual')
                    .requestChange,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Checkbox
                model={{
                  label: intl.formatMessage(
                    { id: 'label.apenasAcoesOrigem' },
                    { acoes: resources.acoes }
                  ),
                  value: model.getModel('apenasAcoesOrigem').value,
                  requestChange:
                    model.getModel('apenasAcoesOrigem').requestChange,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Checkbox
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'acaoCadastradaAprovacao' },
                      { acoes: resources.acoes, acao: resources.acao }
                    )
                  ),
                  value: model.getModel('acaoCadastradaAprovacao').value,
                  requestChange: model.getModel('acaoCadastradaAprovacao')
                    .requestChange,
                }}
              />
            </Col>
          </Row>
        </PanelCollapse>

        {/* 2 - RESPONSÁVEL E ÁREAS */}
        <PanelCollapse
          header={capitalizeFirstLetter(
            intl.formatMessage(
              { id: 'responsavelEAreas' },
              { responsavel: resources.responsavel, areas: resources.areas }
            )
          )}
          open={false}
          ehAccordionDrawer={true}
        >
          <Row>
            <Col md={12}>
              <ColaboradorSimplificadoLookup
                multi={true}
                model={{
                  label: capitalizeFirstLetter(resources.responsaveis),
                  value: model.getModel('responsaveis').value,
                  requestChange: model.getModel('responsaveis').requestChange,
                }}
              />
              {configuracoes?.model?.habilitarEquipe && (
                <Checkbox
                  className="mb-3"
                  model={{
                    label: intl.formatMessage(
                      { id: 'labelConsiderarResponsavelNaEquipe' },
                      { acoes: resources.acoes }
                    ),
                    value: model.getModel('exibirAcoesComoMembroEquipe').value,
                    requestChange: model.getModel('exibirAcoesComoMembroEquipe')
                      .requestChange,
                  }}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ColaboradorSimplificadoLookup
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'responsavelItem' },
                      {
                        responsavel: resources.responsavel,
                        item: resources.item,
                      }
                    )
                  ),
                  value: model.getModel('responsavelItem').value,
                  requestChange:
                    model.getModel('responsavelItem').requestChange,
                }}
              />
            </Col>
          </Row>
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.habilitarEquipe && (
              <Row>
                <Col md={12}>
                  <ColaboradorSimplificadoLookup
                    multi
                    model={{
                      label: intl.formatMessage({ id: 'equipe' }),
                      value: model.getModel('equipe').value,
                      requestChange: model.getModel('equipe').requestChange,
                    }}
                  />
                </Col>
              </Row>
            )}
          <Row>
            <Col md={12}>
              <ItemOrganizacaoLookup
                multi={true}
                model={{
                  label: capitalizeFirstLetter(resources.areas),
                  value: model.getModel('areas').value,
                  requestChange: model.getModel('areas').requestChange,
                }}
                data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              />
              <Checkbox
                style={{ marginBottom: 15 }}
                model={model.getModel('areaSubordinada')}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ItemOrganizacaoLookup
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'label.colaboradoresArea' },
                      {
                        colaboradores: resources.colaboradores,
                        area: resources.area,
                      }
                    )
                  ),
                  value: model.getModel('areaColaboradores').value,
                  requestChange:
                    model.getModel('areaColaboradores').requestChange,
                }}
                data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              />
              <Checkbox
                style={{ marginBottom: 15 }}
                model={model.getModel('areaSubordinadaColaboradores')}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ColaboradorSimplificadoLookup
                model={{
                  label: intl.formatMessage(
                    { id: 'criadorAcao' },
                    { acao: resources.acao }
                  ),
                  value: model.getModel('criadorAcao').value,
                  requestChange: model.getModel('criadorAcao').requestChange,
                }}
              />
            </Col>
          </Row>
        </PanelCollapse>

        {/* 3 - DATAS */}
        <PanelCollapse
          header={capitalizeFirstLetter(intl.formatMessage({ id: 'datas' }))}
          open={false}
          ehAccordionDrawer={true}
        >
          <Row>
            <Col md={6}>
              <DatePicker
                autoFormatDate={true}
                model={model.getModel('dataInicioPrevista')}
              />
            </Col>
            <Col md={6}>
              <DatePicker
                autoFormatDate={true}
                model={model.getModel('dataTerminoPrevista')}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <DatePicker
                autoFormatDate={true}
                model={model.getModel('dataInicioRealizada')}
              />
            </Col>
            <Col md={6}>
              <DatePicker
                autoFormatDate={true}
                model={model.getModel('dataTerminoRealizada')}
              />
            </Col>
          </Row>
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.habilitarBaseline && (
              <>
                <Row>
                  <Col md={6}>
                    <DatePicker
                      autoFormatDate={true}
                      model={{
                        label: intl.formatMessage({ id: 'baselineInicial' }),
                        value: model.getModel('baselineInicial').value,
                        requestChange:
                          model.getModel('baselineInicial').requestChange,
                      }}
                    />
                  </Col>
                  <Col md={6}>
                    <DatePicker
                      autoFormatDate={true}
                      model={{
                        label: intl.formatMessage({ id: 'baselineTermino' }),
                        value: model.getModel('baselineTermino').value,
                        requestChange:
                          model.getModel('baselineTermino').requestChange,
                      }}
                    />
                  </Col>
                </Row>
                {configuracoes.model.exibirStatusBaseLineTermino && (
                  <Row>
                    <Col md={12}>
                      <StatusBaselineLookup
                        clearable
                        model={{
                          label: intl.formatMessage({
                            id: 'labelStatusBaseLine',
                          }),
                          value: model.getModel('statusBaseline').value,
                          requestChange:
                            model.getModel('statusBaseline').requestChange,
                        }}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}
          <Row>
            <Col md={12}>
              <DiasParaVencimentoFilter
                labelDias={intl.formatMessage({ id: 'diasParaVencimento' })}
                labelDiasUteis={intl.formatMessage({ id: 'apenasDiasUteis' })}
                valueDias={model.getModel('diasParaVencimento').value}
                valueUteis={model.getModel('apenasDiasUteis').value}
                onChangeDias={(v) =>
                  model.getModel('diasParaVencimento').requestChange(v)
                }
                onChangeUteis={(v) =>
                  model.getModel('apenasDiasUteis').requestChange(v)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <TipoFiltroDataLookup
                clearable={true}
                options={this.state.options}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'tipoFiltroDataCriacaoAcao' },
                      { acao: resources.acao }
                    )
                  ),
                  value: model.getModel('tipoFiltroDataCriacaoAcao').value,
                  requestChange: (value) => {
                    model
                      .getModel('tipoFiltroDataCriacaoAcao')
                      .requestChange(value);
                  },
                }}
              />
            </Col>
          </Row>

          {model.getModel('tipoFiltroDataCriacaoAcao').value &&
            model.getModel('tipoFiltroDataCriacaoAcao').value.id === 1 && (
              <Row>
                <Col md={6}>
                  <DatePicker
                    autoFormatDate={true}
                    model={{
                      label: capitalizeFirstLetter(
                        intl.formatMessage(
                          { id: 'dataInicialCriacaoAcao' },
                          { acao: resources.acao }
                        )
                      ),
                      value: model.getModel('dataInicialCriacaoAcao').value,
                      requestChange: model.getModel('dataInicialCriacaoAcao')
                        .requestChange,
                    }}
                  />
                </Col>
                <Col md={6}>
                  <DatePicker
                    autoFormatDate={true}
                    model={{
                      label: capitalizeFirstLetter(
                        intl.formatMessage(
                          { id: 'dataFinalCriacaoAcao' },
                          { acao: resources.acao }
                        )
                      ),
                      value: model.getModel('dataFinalCriacaoAcao').value,
                      requestChange: model.getModel('dataFinalCriacaoAcao')
                        .requestChange,
                    }}
                  />
                </Col>
              </Row>
            )}
        </PanelCollapse>

        {/* 4 - INFORMAÇÕES COMPLEMENTARES */}
        <PanelCollapse
          header={capitalizeFirstLetter(
            intl.formatMessage({ id: 'informacoesComplementares' })
          )}
          open={false}
          ehAccordionDrawer={true}
        >
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.utilizarPorque && (
              <Row>
                <Col md={12}>
                  <Input
                    rows={1}
                    type="textarea"
                    model={{
                      label: capitalizeFirstLetter(resources.porque),
                      value: model.getModel('porque').value,
                      requestChange: model.getModel('porque').requestChange,
                    }}
                  />
                </Col>
              </Row>
            )}
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.utilizarComo && (
              <Row>
                <Col md={12}>
                  <Input
                    rows={1}
                    type="textarea"
                    model={{
                      label: capitalizeFirstLetter(resources.como),
                      value: model.getModel('como').value,
                      requestChange: model.getModel('como').requestChange,
                    }}
                  />
                </Col>
              </Row>
            )}
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.utilizarOnde && (
              <Row>
                <Col md={12}>
                  <Input
                    rows={1}
                    type="textarea"
                    model={{
                      label: capitalizeFirstLetter(resources.onde),
                      value: model.getModel('onde').value,
                      requestChange: model.getModel('onde').requestChange,
                    }}
                  />
                </Col>
              </Row>
            )}
          <Row>
            <Col md={12}>
              <PeriodicidadeLookup
                clearable
                model={model.getModel('periodicidade')}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <TemaEstrategicoLookup
                multi={false}
                clearable
                model={{
                  label: capitalizeFirstLetter(resources.temaestrategico),
                  value: model.getModel('tema').value,
                  requestChange: model.getModel('tema').requestChange,
                }}
              />
            </Col>
          </Row>
          {configuracaoSistema.utilizarFuncionalidadeDesdobramento && (
            <Row>
              <Col md={12}>
                <DesdobramentoLookup
                  clearable={true}
                  model={{
                    label: intl.formatMessage({ id: 'desdobramento' }),
                    value: model.getModel('desdobramento').value,
                    requestChange:
                      model.getModel('desdobramento').requestChange,
                  }}
                />
                <Checkbox
                  style={{ marginBottom: 15 }}
                  model={model.getModel('desdobramentoSubordinados')}
                />
              </Col>
            </Row>
          )}
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.exibirGrauDescricaoAcaoVinculadaRisco && (
              <Row>
                <Col md={12}>
                  <GrauRiscoLookup
                    clearable
                    multi
                    model={{
                      label: capitalizeFirstLetter(
                        intl.formatMessage(
                          { id: 'grauRisco' },
                          { risco: resources.risco }
                        )
                      ),
                      value: model.getModel('grausRisco').value,
                      requestChange: model.getModel('grausRisco').requestChange,
                    }}
                  />
                </Col>
              </Row>
            )}
          {configuracoes &&
            configuracoes.model &&
            configuracoes.model.vincularAcaoNaMatriz && (
              <Row>
                <Col md={12}>
                  <MatrizRiscoLookup
                    clearable
                    model={{
                      label: capitalizeFirstLetter(
                        intl.formatMessage(
                          { id: 'matrizRisco' },
                          { risco: this.props.resources.risco }
                        )
                      ),
                      value: model.getModel('matrizRisco').value,
                      requestChange:
                        model.getModel('matrizRisco').requestChange,
                    }}
                  />
                </Col>
              </Row>
            )}
          {moduloAtual.id === 2 && (
            <>
              {exibirClassificacao && (
                <Row>
                  <Col md={12}>
                    <ClassificacaoLookup
                      clearable
                      model={{
                        label: intl.formatMessage({
                          id: 'label.classificacao',
                        }),
                        value: model.getModel('classificacao').value,
                        requestChange:
                          this.handleChangeClassificacao.bind(this),
                      }}
                    />
                  </Col>
                </Row>
              )}
              <Row>
                <Col md={12}>
                  <ItemCentroCustoLookup
                    model={{
                      label: intl.formatMessage(
                        { id: 'centroDeCusto' },
                        { centrocusto: resources.centrocusto }
                      ),
                      value: model.getModel('centroCusto').value,
                      requestChange:
                        model.getModel('centroCusto').requestChange,
                    }}
                    data={{ classificacaoId: classificacaoId }}
                  />

                  <Checkbox
                    className="mt-3"
                    model={{
                      value: model.getModel('centrosSubordinados').value,
                      label: intl.formatMessage(
                        { id: 'label.centrosSubordinados' },
                        { centroscusto: resources.centroscusto }
                      ),
                      requestChange: model.getModel('centrosSubordinados')
                        .requestChange,
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <PacoteLookup
                    model={{
                      label: intl.formatMessage({ id: 'pacoteConta' }),
                      value: model.getModel('pacote').value,
                      requestChange: model.getModel('pacote').requestChange,
                    }}
                    data={{ classificacaoId: classificacaoId }}
                  />
                  <Checkbox
                    model={model.getModel('pacotesSubordinados')}
                    className="mt-3"
                  />
                </Col>
              </Row>
            </>
          )}
        </PanelCollapse>

        {/* 5 - CAMPOS ADICIONAIS */}
        {model.getModel('camposCustomizados').value &&
          model.getModel('camposCustomizados').value.length > 0 && (
            <PanelCollapse
              header={capitalizeFirstLetter(
                intl.formatMessage({ id: 'camposAdicionais' })
              )}
              open={false}
              ehAccordionDrawer={true}
            >
              <Row>
                <Col md={12}>
                  <DesenharCampoCustomizado
                    model={model.getModel('camposCustomizados')}
                    mdFields={12}
                  />
                </Col>
              </Row>
            </PanelCollapse>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    moduloAtual: state.user.moduloAtual,
    configuracaoSistema: state.user.configuracao,
    addons: state.user.addonsDisponiveis,
  };
}

export default injectIntl(connect(mapStateToProps)(OrganizacaoSearch));
